/**
 * @returns {boolean} check sessionStorage for debug flag
 */
 export function isDebug(): boolean {
    let isDebug = false
    try {
        isDebug = JSON.parse(sessionStorage.debug)
    } catch {
        isDebug = false
    }
    return isDebug
}
